import { Box } from '@radix-ui/themes';
import { useState } from 'react';
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
  pointerWithin,
} from '@dnd-kit/core';

import LoadingComponent from '../../shared/LoadingComponent';
import { GoalsContent } from './components';
import DraggedGoal from './components/DraggedGoal.jsx';
import { useGoalsQuery } from './hooks/useGoalQuery';
import { useGoalDragDrop } from './hooks/useGoalDragDrop';
import {
  getDisplayGoals,
  groupGoalsByYear,
  getSortedYears,
} from './utils/goalsUtils';

const Goals = () => {
  const { goals, isLoadingGoals } = useGoalsQuery();
  const [recentlyMovedGoalId, setRecentlyMovedGoalId] = useState(null);

  const {
    localGoals,
    activeGoal,
    currentTargetPosition,
    handleDragStart,
    handleDragOver,
    handleDragEndEvent,
  } = useGoalDragDrop(goals, setRecentlyMovedGoalId);

  const displayGoals = getDisplayGoals(localGoals);
  const groupedGoals = groupGoalsByYear(displayGoals);
  const years = getSortedYears(groupedGoals);

  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 5,
    },
  });
  const sensors = useSensors(pointerSensor);

  if (isLoadingGoals) {
    return (
      <Box p="5">
        <LoadingComponent />
      </Box>
    );
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={pointerWithin}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragEnd={handleDragEndEvent}
    >
      <GoalsContent
        years={years}
        groupedGoals={groupedGoals}
        recentlyMovedGoalId={recentlyMovedGoalId}
        setRecentlyMovedGoalId={setRecentlyMovedGoalId}
        currentTargetPosition={currentTargetPosition}
        activeGoal={activeGoal}
      />
      <DragOverlay
        dropAnimation={{
          duration: 200,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        }}
      >
        {activeGoal ? (
          <DraggedGoal
            goal={activeGoal}
            currentTargetPosition={currentTargetPosition}
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  );
};

export default Goals;
